export const GC_USER_ID = 'user-id'
export const GC_AUTH_TOKEN = 'auth-token'